const data = {
  id: 1,
  title: 'Listen and fill the blank with the correct word',
  subTitle: 'Nghe và điền từ',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/259ba124-d79c-44ff-b3f3-5ed43655c661.mp3',
  imageUrl: '',
  question: 'Where is she from? \r\n She is from ___.',
  // answers: 'America',
  answers: [
    { id: 1, answer: 'America', isCorrect: true },
  ],
};

export default data;
